import React from "react";

function Goals() {
  return (
    <>
      <section className="activities">
        <h3 className="heading">
          <span>Vision and Objectives</span>
        </h3>
        <div className="container">
          <div className="container-content">
            <p className="urdu">
              قرآن اور اہلِ بیت کے ساتھ تعلق کی حفاظت کرنا
              <span>
                ہمارا مقصد قرآن اور اہلِ بیت کے ساتھ مضبوط تعلق قائم رکھنا ہے۔
                ہم مختلف تعلیمی پروگرام اور سرگرمیوں کے ذریعے ان کی حکمت، ہدایات
                اور تعلیمات کی گہری سمجھ پیدا کرنے پر توجہ دیتے ہیں، تاکہ افراد
                انہیں اپنی روزمرہ زندگی میں شامل کر سکیں۔
              </span>
            </p>
            <p className="urdu">
              مذہبی آگاہی اور بصیرت کا پیدا کرنا
              <span>
                ہم دینی آگاہی کو بڑھانے اور اسلامی تعلیمات کی گہری سمجھ کو
                نشوونما دینے پر توجہ دیتے ہیں۔ مختلف تعلیمی پروگرام اور سرگرمیوں
                کے ذریعے ہم افراد کو دین کے بنیادی اصول، قیمتوں اور عملی عملات
                کی روشنی میں لانے کی کوشش کرتے ہیں، جو انہیں روحانی طور پر پوری
                زندگی گزارنے میں مدد کرتے ہیں۔
              </span>
            </p>
            <p className="urdu">
              اصلِ انتظار کاروں کے ذمہ داریوں کی آگاہی دینے کے ذریعے راہبری کرنا
              <span>
                ہمارا مقصد اصلِ انتظار کاروں کی حالاتِ حاضرہ میں ان کے ذمہ
                داریوں کی آگاہی دینا ہے۔ امام زمان عج کی تعلیمات کی روشنی میں
                انہیں راہنمائی اور آگاہ کرنے کے ذریعے ہم افراد کو تحریک دینے کی
                کوشش کرتے ہیں کہ وہ معاشرتی اور انسانیتی بہتری کے لئے فعالیت
                کریں۔
              </span>
            </p>
            <p className="urdu">
              اجتہاد، تقلید اور ولایت فقیہ کی تعلیم و فہم کی ترقی
              <span>
                ہمارا ہدف اجتہاد (خود مختار رائے دہی)، تقلید (مذہبی مقتدا) اور
                ولایت فقیہ (فقیہ کی حکمرانی) کے تصورات کی تعلیم و فہم کو ترقی
                دینا ہے۔ تعلیمی پروگرام اور سیمیناروں کے ذریعے ہم ان تصورات کی
                تفصیلی سمجھ پیدا کرنے پر توجہ دیتے ہیں، تاکہ افراد احساس مند اور
                مستند فیصلے کر سکیں اور دینی مسائل کو بہتر طریقے سے حل کر سکیں۔
              </span>
            </p>
            <p className="urdu">
              نوجوانوں اور عالمانِ دین سے نزدیک و دوستانہ تعلق قائم رکھنا
              <span>
                ہم نوجوانوں اور عالمانِ دین کے ساتھ نزدیک و دوستانہ تعلق قائم
                رکھنے پر توجہ دیتے ہیں۔ علماء کی مدد اور راہنمائی کے لئے ایک
                پلیٹ فارم فراہم کرکے ہم یقینی بناتے ہیں کہ افراد زندگی کے مختلف
                شعبوں اور مشکلات کے میدان میں علماء سے راہنمائی حاصل کر سکتے
                ہیں۔
              </span>
            </p>
            <p className="urdu">
              مذہبی اور سماجی مسائل سے متعلق شبہات کا جواب دینا
              <span>
                ہم عمومی افراد کو مذہبی اور سماجی مسائل سے متعلق شبہات کا جواب
                دینے کی میں مقصد رکھتے ہیں۔ ہماری ماہرین اور علماء کی ٹیم دستیاب
                ہوتی ہے تاکہ وہ سوالات کا جواب دیں، قرآنی تصورات کو سمجھائیں اور
                اسلام کے بارے میں درست معلومات فراہم کریں۔ ہم درست معلومات کی
                فراہمی کے ذریعے تفہیم کو فروغ دینے اور غلط فہمیوں کو دور کرنے کی
                کوشش کرتے ہیں۔
              </span>
            </p>
            <p className="urdu">
              انٹرنیٹ اور سوشل میڈیا کو مثبت طریقے سے استعمال کرنے کا تشریع کرنا
              <span>
                ہم لوگوں کو بتاتے ہیں کہ انٹرنیٹ اور سوشل میڈیا کو مثبت طریقے سے
                استعمال کرنے کیسے کیا جائے۔ ہم مشورہ دیتے ہیں کہ کس طرح انٹرنیٹ
                کو تعلیمی، انفرادی اور سماجی فائدہ دینے میں مدد کی جا سکتی ہے۔
              </span>
            </p>
            <p className="urdu">
              نوجوانوں کو اچھے اور مناسب دوستوں کا انتخاب میں رہنمائی کرنا
              <span>
                ہم نوجوانوں کو مدد کرتے ہیں اور راہنمائی کرتے ہیں کہ وہ اچھے اور
                مناسب دوستوں کو کیسے منتخب کر سکتے ہیں۔ اچھے دوستوں کے چناؤ میں
                مدد کرکے ہم نوجوانوں کو پوزیٹو اور صحیح راہ پر چلنے میں مدد کرتے
                ہیں۔
              </span>
            </p>
            <p className="urdu">
              کیریئر گائیڈنس اور تعلیمی شعبے میں پسندیدہ اور اچھے مضمون کا
              انتخاب میں رہنمائی کرنا
              <span>
                ہم نوجوانوں کی کیریئر گائیڈنس کرتے ہیں اور انہیں تعلیمی شعبے میں
                پسندیدہ اور اچھے مضمون کا انتخاب کرنے میں رہنمائی کرتے ہیں۔ ہم
                انہیں انفرادی استعدادوں، علاقائی موقعوں اور عملی ضروریات کے
                مطابق مشورہ دیتے ہیں تاکہ وہ اپنے تعلیمی سفر میں کامیاب ہو سکیں
              </span>
            </p>
            <p className="urdu">
              نوجوانوں کو بڑے اور عظیم مقاصد حاصل کرنے کی راہنمائی کرنا جبکہ ان
              کی زندگی میں تازگی اور تازگی کو برقرار رکھنا
              <span>
                ہم نوجوانوں کو راہنمائی کرتے ہیں کہ وہ بڑے اور عظیم مقاصد حاصل
                کرنے کی راہ پر چلیں۔ ہم انہیں ترقی اور فروغ کیلئے مشورہ دیتے
                ہیں، جبکہ ان کی زندگی میں تازگی اور تازگی کو برقرار رکھنے کی
                کوشش کرتے ہیں۔
              </span>
            </p>
            <p className="urdu">
              نوجوانوں کو زندگی میں انضباط اور تقوی کی حاصل کرنے کی راہنمائی
              کرنا
              <span>
                ہم نوجوانوں کو زندگی میں انضباط اور تقوی کی حاصل کرنے کی
                راہنمائی کرتے ہیں۔ ہم انہیں زندگی کی تمام شعبوں میں اخلاقی اور
                دینی اقدار کی حاصل کرنے کی سمجھ پیدا کرتے ہیں تاکہ وہ زندگی کو
                پرامن اور متعادل طریقے سے گزار سکیں۔
              </span>
            </p>
            <p className="urdu">
              نوجوانوں کو امتحانات اور دیگر تعلیمی دباؤ کے ساتھ کام کرنے کی
              راہنمائی کرنا
              <span>
                ہم نوجوانوں کو امتحانات اور دیگر تعلیمی دباؤ کے ساتھ کام کرنے کی
                راہنمائی کرتے ہیں۔ ہم انہیں پڑھائی کے استراتیجیوں، وقت کی منظم
                کرنے کے طریقوں اور تنظیمی مہارتوں پر مشورہ دیتے ہیں تاکہ وہ
                امتحانات میں کامیابی حاصل کر سکیں اور دیگر تعلیمی دباؤ کے ساتھ
                سامانے کا مقابلہ کر سکیں
              </span>
            </p>
          </div>
          <div className="container-content intro">
            <p className="english">
              To Maintain The Relationship with the Qur'an and Ahl al-Bayt
              <span>
                Our objective is to foster a deep connection and strong bond
                with the Qur'an and the teachings of Ahl al-Bayt. We strive to
                promote a profound understanding of their wisdom, guidance, and
                teachings, enabling individuals to incorporate these principles
                into their daily lives.
              </span>
            </p>

            <p className="english">
              Creating Religious Awareness and Insight
              <span>
                We are dedicated to raising religious awareness and nurturing a
                deeper understanding of Islamic teachings. Through various
                educational programs and activities, we aim to enlighten
                individuals about the core principles, values, and practices of
                the faith, empowering them to lead a spiritually fulfilling
                life.
              </span>
            </p>

            <p className="english">
              Guiding the Way as True Awaiters
              <span>
                As true awaiters of the reappearance of Imam Zaman AJ, we aim to
                guide and enlighten individuals about their roles and
                responsibilities in preparing for his arrival. By imparting
                knowledge and insights into the teachings of Imam Zaman AJ, we
                strive to inspire individuals to actively contribute to the
                betterment of society and humanity.
              </span>
            </p>

            <p className="english">
              Developing Knowledge and Insight into Ijtihad, Taqlid, and Wilayat
              Faqih
              <span>
                Our goal is to enhance knowledge and insight regarding the
                concepts of ijtihad (independent reasoning), taqlid (religious
                emulation), and wilayat faqih (guardianship of the jurist).
                Through educational programs and seminars, we aim to foster a
                critical understanding of these concepts, enabling individuals
                to make informed decisions and navigate religious matters
                effectively.
              </span>
            </p>

            <p className="english">
              Maintaining Close Contact with Youth and Religious Scholars
              <span>
                We believe in maintaining a close and friendly relationship with
                the youth and religious scholars. By providing a platform for
                guidance and support, we ensure that individuals can seek advice
                and assistance from knowledgeable scholars in various fields and
                difficulties they may encounter in life.
              </span>
            </p>

            <p className="english">
              Addressing Doubts related to Religious and Social Issues
              <span>
                We are committed to addressing doubts and concerns related to
                religious and social issues. Our team of experts and scholars
                provides accurate and authentic answers to questions, helping
                individuals gain clarity and understanding on matters that may
                affect their faith and daily lives.
              </span>
            </p>

            <p className="english">
              Promoting Positive Internet and Social Media Usage
              <span>
                We emphasize the responsible and positive use of the internet
                and social media platforms. Through workshops and educational
                campaigns, we guide individuals on utilizing these tools to
                spread knowledge, engage in meaningful dialogue, and uphold
                ethical and moral values online.
              </span>
            </p>

            <p className="english">
              Assisting and Guiding Youth in Choosing Good Company
              <span>
                We offer support and guidance to youth in choosing good and
                suitable friends. Through mentoring programs and counseling
                services, we help individuals foster healthy relationships and
                surround themselves with positive influences that align with
                their values and aspirations.
              </span>
            </p>

            <p className="english">
              Career Guidance and Academic Subject Selection
              <span>
                We provide career guidance and assistance in choosing suitable
                academic subjects. Our experts offer personalized counseling and
                advice, helping youth make informed decisions about their
                educational and career paths, ensuring alignment with their
                interests, talents, and future goals.
              </span>
            </p>

            <p className="english">
              Inspiring Youth to Achieve Greatness while Maintaining Vitality
              <span>
                Our aim is to inspire youth to set lofty goals and aspirations
                while maintaining vitality and freshness in their lives. Through
                motivational programs and mentoring, we encourage young
                individuals to pursue excellence in all aspects of life,
                empowering them to make a positive impact on society.
              </span>
            </p>

            <p className="english">
              Promoting Discipline and Piety in Life
              <span>
                We strive to guide youth towards adopting discipline and piety
                in their lives. Through educational programs and spiritual
                guidance, we instill values of self-discipline, self-reflection,
                and mindfulness, fostering a balanced and righteous lifestyle.
              </span>
            </p>

            <p className="english">
              Cultivating High Human, Islamic, and Moral Values
              <span>
                Our mission is to cultivate high human, Islamic, and moral
                values among the youth. Through character-building initiatives,
                ethical teachings, and community service projects, we aim to
                nurture individuals who exemplify integrity, compassion, and
                social responsibility, contributing to the betterment of
                society.
              </span>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Goals;
